import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
export const MealSaboIcon = ({ classObject, recordedMealCount }) => {
    let src = '/assets/images/icons/meal_sabo_complete.png';
    if (recordedMealCount === 0) {
        src = '/assets/images/icons/meal_sabo_empty.png';
    }
    else if (recordedMealCount < 3) {
        src = '/assets/images/icons/meal_sabo_recorded.png';
    }
    return React.createElement("img", { className: css(styles.icon, classObject), src: src });
};
const styles = StyleSheet.create({
    icon: {
        width: 68,
        height: 68,
    },
});
